import { mixinActions, mixinMutations, mixinState, mixinGetters } from '../../mixins/vuexCRUD'

const getters = {
  ...mixinGetters(),
  drivers: (state) => state.items,
}

const state = {
  ...mixinState(),
  path: '/drivers',
}

const mutations = mixinMutations()

const actions = mixinActions()

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
